<template>
  <div
      class="popover-trigger"
      @mouseover.stop="showPopover"
      @click.stop="showPopover"
      @mouseleave="hidePopover"
      :class="[dir === 'left' ? 'dir-left' : (dir === 'bottom' ? 'dir-bottom' : '')]"
  >
    <slot name="trigger"></slot>
    <div class="popover" v-if="isPopoverVisible" @click="closePopover" :ref="refKey" >
      <div class="popover-content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Popover",
  props: [
      'dir', 'refKey'
  ],
  data() {
    return {
      isPopoverVisible: false,
    };
  },
  methods: {
    showPopover() {
      this.isPopoverVisible = true;
      document.addEventListener('click', this.handleClickOutside);
    },
    hidePopover() {
      this.isPopoverVisible = false;
      document.removeEventListener('click', this.handleClickOutside);
    },
    closePopover() {
      this.isPopoverVisible = false;
      document.removeEventListener('click', this.handleClickOutside);
    },
    handleClickOutside(event) {
      const popover = this.$refs[this.refKey];

      if (!(popover && popover.contains(event.target))) {
        this.hidePopover();
      }
    }
  },
}
</script>

<style scoped lang="scss">
.popover {
  position: absolute;
  background-color: #ffffff;
  border: 1px solid #707070;
  //border-radius: 4px;
  padding: 10px;
  z-index: 1000;

  left: -5px;
}

.popover-content {
  //&::after {
  //  border-color: #fff transparent;
  //  border-style: solid;
  //  border-width: 8px 6.5px 0 6px;;
  //  content: '';
  //  display: block;
  //  left: 5px;
  //  position: absolute;
  //  bottom: -7px;
  //  width: 0;
  //  z-index: 1;
  //}
  //
  //&::before {
  //  border-color: #c2c2c2 transparent;
  //  border-style: solid;
  //  border-width: 8px 6.5px 0 6px;;
  //  content: '';
  //  display: block;
  //  left: 5px;
  //  position: absolute;
  //  bottom: -8px;
  //  width: 0;
  //  z-index: 0;
  //}
  //&::after {
  //  content: '';
  //  position: absolute;
  //  bottom: 0;
  //  left: 50%;
  //  width: 0;
  //  height: 0;
  //  border: 8px solid transparent;
  //  border-top-color: #00aabb;
  //  border-bottom: 0;
  //  margin-left: -8px;
  //  margin-bottom: -8px;
  //}
}

.popover-trigger {
  position: relative;
  display: inline-block;
}

.dir-left {

  .popover {
    top: -5px;
    right: -5px;
    left: initial;
    transform: translate(0, -100%);
  }

  .popover-content {
    &::before, &::after {
      left: initial;
      right: 5px;
    }
  }
}

.dir-bottom {
  .popover {
    top: 20px;
  //  transform: translate(0, 100%);
  }
}
</style>
